export const formatFloat = (n: number | undefined = 0) =>
  n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatInt = (n: number | undefined = 0) =>
  n.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

// formats and returns string representation
export const formatNumber = (n: number | undefined = 0) =>
  isNaN(n) ? "0.00" : Number.isInteger(n) ? formatInt(n) : formatFloat(n);

export const stringToFloat = (s: string) =>
  parseFloat((s || "").replace(/,/g, ""));

export const sumArray = (arr: number[]): number => {
  return arr.reduce((a, b) => a + b, 0);
};

export const avgArray = (arr: number[]): number => {
  return sumArray(arr) / arr.length || 0;
};

export function formatToKM(num: number, decimalPlaces?: number): string {
  const million = 1000000;
  const thousand = 1000;

  const formatNumber = (n: number) => {
    if (decimalPlaces !== undefined) {
      return n.toLocaleString(undefined, {
        minimumFractionDigits: decimalPlaces,
        maximumFractionDigits: decimalPlaces,
      });
    }
    return formatInt(n);
  };

  if (num >= million) {
    return formatNumber(num / million) + "M";
  } else if (num >= thousand) {
    return formatNumber(num / thousand) + "k";
  }
  return formatNumber(num);
}

export const centsToDollars = (
  n: number | undefined = 0,
  decimalPlaces?: number,
) => {
  const v = n / 100;
  return formatToKM(v, decimalPlaces);
};

export const getOrdinalSuffix = (num: number): string => {
  if (num % 100 >= 11 && num % 100 <= 13) {
    return `${num}th`;
  }

  switch (num % 10) {
    case 1:
      return `${num}st`;
    case 2:
      return `${num}nd`;
    case 3:
      return `${num}rd`;
    default:
      return `${num}th`;
  }
};
